import React, { Component } from "react";
import axios from "axios";
import api from "../api";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = theme => ({
  menu: {
    fontSize: "0.75rem"
  },
  /*column:{
	  maxWidth: '110px',
	  whiteSpace: 'nowrap',
	  textOverflow: 'ellipsis',
	  overflow: 'hidden' 
  },*/
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  }
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class UserAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      user_alerts: [],
      reclaim_to: "",
      reclaim_to_type: "",
      reclaim_types: [],
      subject_types: [],
      comment_types: [],
      user_alert: {
        subject: "",
        alert_date: "",
        completed: 0,
        send_mail: 0,
        user_id: null
      },
      user_alert_dropdowns: {}
    };
  }

  async componentDidMount() {
    var work_order_id = this.props.work_order_id;
    this.getProfile();
    this.getWorkOrderAlertsDropdowns();
    this.getWorkOrderAlertsReclaimTypes();
    this.getWorkOrderCommentsTypes();
    this.getWorkOrderReasonsTypes();
    this.getWorkOrderAlerts(work_order_id);
    this.getUsers();
  }

  getProfile = async () => {
    const token = localStorage.getItem("userToken");

    await axios
      .get(api.user, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(async res => {
        var user_alert = this.state.user_alert;
        user_alert.user_id = res.data.id;
        this.setState({ user_alert: user_alert });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderAlerts = async id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_alerts().index(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var user_alerts = res.data;
        this.setState({ user_alerts: user_alerts });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getUsers = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order().users(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var users = res.data;
        this.setState({ users: users });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderAlertsReclaimTypes = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_alerts().reclaim_types(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var reclaim_types = res.data;
        this.setState({ reclaim_types: reclaim_types });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderReasonsTypes = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_alerts().reasonsTypes(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var subject_types = Object.values(res.data);
        this.setState({ subject_types: subject_types });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderCommentsTypes = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_alerts().commentsTypes(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var comment_types = Object.values(res.data);
        this.setState({ comment_types: comment_types });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderAlertsDropdowns = async () => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.work_order_alerts().dropdowns(this.props.work_order_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var user_alert_dropdowns = res.data;
        this.setState({ user_alert_dropdowns: user_alert_dropdowns });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleChange = e => {
    var user_alert = this.state.user_alert;
    if (e.target.name === "completed" || e.target.name === "send_mail") {
      e.target.value = e.target.checked;
    }

    user_alert[e.target.name] = e.target.value;
    if (e.target.name === "subject_type" && e.target.value != "Otros") {
      user_alert.next_reclaim_subject = e.target.value;
    }
    if (e.target.name === "comment_type" && e.target.value != "Otros") {
      user_alert.subject = e.target.value;
    }
    this.setState({ user_alert: user_alert });
  };

  handleSubmit = () => {
    var formData = new FormData();
    var url = api.work_order_alerts().post();
    formData.set("user_alert[work_order_id]", this.props.work_order_id);
    formData.set("user_alert[user_id]", this.state.user_alert.user_id);
    formData.set("user_alert[subject]", this.state.user_alert.subject);
    formData.set(
      "user_alert[alert_date]",
      this.state.user_alert.alert_date.replace("T", " ")
    );
    formData.set(
      "user_alert[reclaim_to_type]",
      this.state.user_alert.reclaim_to_type
        ? this.state.user_alert.reclaim_to_type
        : "Otros"
    );
    formData.set(
      "user_alert[reclaim_type]",
      this.state.user_alert.reclaim_type
        ? this.state.user_alert.reclaim_type
        : ""
    );
    formData.set(
      "user_alert[reclaim_to]",
      this.state.user_alert.reclaim_to ? this.state.user_alert.reclaim_to : ""
    );
    formData.set(
      "user_alert[next_reclaim_subject]",
      this.state.user_alert.next_reclaim_subject
        ? this.state.user_alert.next_reclaim_subject
        : ""
    );
    formData.set(
      "user_alert[send_mail]",
      this.state.user_alert.send_mail === true ||
        this.state.user_alert.send_mail === "true"
        ? 1
        : 0
    );
    formData.set(
      "user_alert[completed]",
      this.state.user_alert.completed === true ||
        this.state.user_alert.completed === "true"
        ? 1
        : 0
    );
    if (this.state.user_alert.id > 0) {
      url = api.work_order_alerts().patch(this.state.user_alert.id);
      formData.set("_method", "PATCH");
      formData.set("user_alert[id]", this.state.user_alert.id);
    }
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var user_alert = {
          subject: "",
          alert_date: "",
          reclaim_to: "",
          reclaim_type: "",
          next_reclaim_subject: ""
        };
        self.setState({
          user_alert: user_alert,
          openSuccess: true,
          success_message: "Alerta cargada con éxito",
          severity: "success"
        });
        this.getWorkOrderAlerts(self.props.work_order_id);
      })
      .catch(function(error) {
        var error_message = "Ha ocurrido un error al cargar la alerta";
        self.setState({
          openSuccess: true,
          success_message: error_message,
          severity: "warning"
        });
      });
  };

  handleExport = e => {
    var url = api.work_order_alerts().export(this.props.work_order_id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .get(url, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
      })
      .catch(function(error) {
        var error_message = "Ha ocurrido al exportar las alertas";
        self.setState({
          openSuccess: true,
          success_message: error_message,
          severity: "warning"
        });
      });
  };

  handleCloseSuccess = () => {
    this.setState({ openSuccess: false, success_message: "" });
    this.getWorkOrderAlerts(this.props.work_order_id);
  };

  handleEdit = id => {
    var user_alerts = this.state.user_alerts;
    var user_alert = user_alerts[id];
    user_alert.alert_date = user_alert.alert_date.replace(" ", "T");
    user_alert.send_mail =
      user_alert.send_mail === "1" || user_alert.send_mail === 1
        ? "true"
        : "false";
    user_alert.completed =
      user_alert.completed === "1" || user_alert.completed === 1
        ? "true"
        : "false";
    user_alert.subject_type =
      this.state.subject_types.filter(s => s == user_alert.next_reclaim_subject)
        .length > 0
        ? user_alert.next_reclaim_subject
        : "Otros";
    user_alert.comment_type =
      this.state.comment_types.filter(s => s == user_alert.subject).length > 0
        ? user_alert.subject
        : "Otros";
    this.setState({ user_alert: user_alert });
  };

  handleContactChange = (e, values) => {
    var user_alert = this.state.user_alert;
    if (values) {
      user_alert.reclaim_to = values.firstname + " " + values.lastname;
    } else {
      user_alert.reclaim_to = "";
    }
    this.setState({ user_alert });
  };

  render() {
    const classes = this.props.classes;
    var reclaim_tos = [];
    var reclaim_to_type = "select";
    switch (this.state.user_alert.reclaim_to_type) {
      case "provider":
        reclaim_tos = this.state.user_alert_dropdowns.provider_subcontacts
          ? this.state.user_alert_dropdowns.provider_subcontacts
          : [];
        break;
      case "broker":
        reclaim_tos = this.state.user_alert_dropdowns.broker_subcontacts
          ? this.state.user_alert_dropdowns.broker_subcontacts
          : [];
        break;
      case "driver":
        if (this.state.user_alert_dropdowns.driver)
          reclaim_tos.push(this.state.user_alert_dropdowns.driver);
        //reclaim_tos.push(this.state.user_alert_dropdowns.driver)
        break;
      case "client":
        reclaim_tos = this.state.user_alert_dropdowns.client_subcontacts
          ? this.state.user_alert_dropdowns.client_subcontacts
          : [];
        break;
      case "Otros":
        reclaim_tos = [];
        reclaim_to_type = "text";
        break;
      default:
        break;
    }

    if (reclaim_tos.length === 0) {
      reclaim_to_type = "text";
    }

    const reclaim_to_types = [
      { id: "provider", name: "Proveedor" },
      { id: "broker", name: "Broker" },
      { id: "client", name: "Cliente" },
      { id: "driver", name: "Conductor" },
      { id: "Otros", name: "Otros" }
    ];
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.openSuccess}
          autoHideDuration={10000}
          onClose={this.handleCloseSuccess}
        >
          <Alert
            onClose={this.handleCloseSuccess}
            severity={this.state.severity}
          >
            {this.state.success_message}
          </Alert>
        </Snackbar>
        <div className="row mb-2 mt-2">
          <div className="col-12 mt-2">
            <Typography variant="subtitle2">Nueva alerta</Typography>
            <TextField
              id="user_id"
              name="user_id"
              margin="normal"
              className="mr-2 mt-1"
              value={
                this.state.user_alert.user_id
                  ? this.state.user_alert.user_id
                  : ""
              }
              InputLabelProps={{
                shrink: true
              }}
              select
              onChange={this.handleChange}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Operador</Typography>
                  </InputAdornment>
                )
              }}
            >
              {this.state.users.map(option => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  className={classes.menu}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="reclaim_to_type"
              name="reclaim_to_type"
              margin="normal"
              className="mr-2 mt-1"
              value={
                this.state.user_alert.reclaim_to_type
                  ? this.state.user_alert.reclaim_to_type
                  : ""
              }
              InputLabelProps={{
                shrink: true
              }}
              select
              onChange={this.handleChange}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Reclamar a</Typography>
                  </InputAdornment>
                )
              }}
            >
              {reclaim_to_types.map(option => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  className={classes.menu}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            {this.state.user_alert.id > 0 || reclaim_to_type === "text" ? (
              <TextField
                id="reclaim_to"
                name="reclaim_to"
                margin="normal"
                className="mr-2 mt-1"
                value={
                  this.state.user_alert.reclaim_to
                    ? this.state.user_alert.reclaim_to
                    : ""
                }
                InputLabelProps={{
                  shrink: true
                }}
                select={reclaim_to_type === "select" ? true : false}
                type={reclaim_to_type}
                onChange={this.handleChange}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  style: { fontSize: "0.75rem" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Contacto</Typography>
                    </InputAdornment>
                  )
                }}
              >
                {reclaim_tos.map(option => (
                  <MenuItem
                    key={option}
                    value={option.firstname + " " + option.lastname}
                    className={classes.menu}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.firstname + " " + option.lastname}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <FormControlLabel
                className="mx-0 my-0"
                style={{ alignItems: "baseline" }}
                label={
                  <Typography variant="caption" style={{ width: 75 }}>
                    Contacto
                  </Typography>
                }
                labelPlacement="start"
                control={
                  <Autocomplete
                    id="reclaim_to"
                    style={{ width: 225, marginTop: 4 }}
                    getOptionLabel={option =>
                      option.firstname + " " + option.lastname
                    }
                    getOptionSelected={(option, value) =>
                      option.firstname + " " + option.lastname === value
                    }
                    options={reclaim_tos}
                    onChange={this.handleContactChange.bind(this)}
                    autoComplete
                    noOptionsText={
                      <Typography variant="caption">Sin resultados</Typography>
                    }
                    name="reclaim_to"
                    includeInputInList
                    classes={{
                      option: classes.option
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        id="reclaim_to"
                        name="reclaim_to"
                        autoComplete="off"
                        //      	              error={(this.state.vehicle.work_orders[0]) ? true : false }
                        FormHelperTextProps={{
                          className: classes.helperText
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          )
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "contact_name",
                          style: {
                            fontSize: "0.75rem",
                            width: 225,
                            marginLeft: 8
                          }
                        }}
                      />
                    )}
                  />
                }
              />
            )}

            <TextField
              id="subject_type"
              name="subject_type"
              margin="normal"
              select
              className="mr-2 mt-1"
              value={
                this.state.user_alert.subject_type
                  ? this.state.user_alert.subject_type
                  : ""
              }
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      Motivo Próx. Reclamo
                    </Typography>
                  </InputAdornment>
                )
              }}
            >
              {this.state.subject_types.map(option => (
                <MenuItem
                  key={option}
                  value={option}
                  className={classes.menu}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {this.state.user_alert.subject_type === "Otros" && (
              <TextField
                id="next_reclaim_subject"
                name="next_reclaim_subject"
                margin="normal"
                className="mr-2 mt-1"
                value={this.state.user_alert.next_reclaim_subject}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={this.handleChange}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Motivo Próx. Reclamo
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
            )}
            <TextField
              id="reclaim_type"
              name="reclaim_type"
              margin="normal"
              select
              className="mr-2 mt-1"
              value={
                this.state.user_alert.reclaim_type
                  ? this.state.user_alert.reclaim_type
                  : ""
              }
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Tipo de reclamo</Typography>
                  </InputAdornment>
                )
              }}
            >
              {this.state.reclaim_types.map(option => (
                <MenuItem
                  key={option}
                  value={option}
                  className={classes.menu}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="comment_type"
              name="comment_type"
              margin="normal"
              select
              className="mr-2 mt-1"
              value={
                this.state.user_alert.comment_type
                  ? this.state.user_alert.comment_type
                  : ""
              }
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                style: { fontSize: "0.75rem" },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Observaciones</Typography>
                  </InputAdornment>
                )
              }}
            >
              {this.state.comment_types.map(option => (
                <MenuItem
                  key={option}
                  value={option}
                  className={classes.menu}
                  style={{ fontSize: "0.75rem" }}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="subject"
              name="subject"
              margin="normal"
              fullWidth
              className="mr-2 mt-1"
              value={this.state.user_alert.subject}
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              inputProps={{ style: { fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Notas</Typography>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              id="alert_date"
              name="alert_date"
              type="datetime-local"
              margin="normal"
              className="mr-2 mt-1"
              value={this.state.user_alert.alert_date}
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Fecha de alerta</Typography>
                  </InputAdornment>
                )
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name={"send_mail"}
                  id={"send_mail"}
                  checked={
                    this.state.user_alert.send_mail === "true" ? true : false
                  }
                  value={this.state.user_alert.send_mail}
                  onChange={this.handleChange}
                />
              }
              label={
                <Typography variant="caption">
                  Enviar mail al operador?
                </Typography>
              }
              labelPlacement="start"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name={"completed"}
                  id={"completed"}
                  checked={
                    this.state.user_alert.completed === "true" ? true : false
                  }
                  value={this.state.user_alert.completed}
                  onChange={this.handleChange}
                />
              }
              label={<Typography variant="caption">Finalizado?</Typography>}
              labelPlacement="start"
            />

            <Button
              disabled={
                this.state.user_alert.alert_date !== "" &&
                this.state.user_alert.subject !== ""
                  ? false
                  : true
              }
              className="mt-1"
              variant="contained"
              color="primary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={e => {
                this.handleSubmit(e);
              }}
            >
              Guardar
            </Button>
          </div>
          <div className="col-12 mt-2">
            <Table
              size="small"
              aria-label="a dense table"
              style={{ width: "auto" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "550" }}>
                    Fecha de carga
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>Usuario</TableCell>
                  <TableCell style={{ fontWeight: "550" }}>
                    Fecha alerta
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>
                    Tipo reclamo
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>
                    Próximo reclamo
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>
                    Observaciones
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>
                    Reclamar a:
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>
                    Finalizado
                  </TableCell>
                  <TableCell style={{ fontWeight: "550" }}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.user_alerts.map((val, idx) => {
                  var inlineStyle = "";
                  if (val.id === this.state.user_alert.id) {
                    inlineStyle = "2px solid red";
                  }
                  return (
                    <TableRow key={idx} style={{ border: inlineStyle }}>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.created_at.replace("T", " ")}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.user.name}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.alert_date_formatted.replace("T", " ")}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.reclaim_type}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.next_reclaim_subject}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.subject}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.reclaim_to}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        {val.completed === 1 ||
                        val.completed === "1" ||
                        val.completed === true ||
                        val.completed === "true"
                          ? "Si"
                          : "No"}
                      </TableCell>
                      <TableCell
                        className={classes.column}
                        style={{ fontSize: "0.7rem" }}
                      >
                        <EditIcon
                          fontSize="small"
                          onClick={e => this.handleEdit(idx)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            {this.state.user_alerts.length > 0 ? (
              <Button
                className="mt-1"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleExport(e);
                }}
              >
                Exportar
              </Button>
            ) : (
              ""
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(UserAlerts);
